/* Ashwath Trendz - collection page: footer link columns become accordions on phones.
   Loaded only by sections/main-collection.liquid. The markup is the theme's own (.ft-nav-col > h4 + ul); this only
   adds button semantics and an is-open class. The matching CSS lives in collection-mobile.css. */
(() => {
  const footer = document.querySelector('main[data-template="collection"] ~ footer');
  const columns = footer ? footer.querySelectorAll('.ft-nav-col') : [];
  if (!columns.length) return;

  const phone = window.matchMedia('(max-width: 749px)');
  const items = [];

  columns.forEach((column, index) => {
    const heading = column.querySelector('h4');
    const list = column.querySelector('ul');
    if (!heading || !list) return;

    list.id = list.id || `cp-footer-links-${index}`;

    const toggle = () => {
      if (!phone.matches) return;
      const open = column.classList.toggle('is-open');
      heading.setAttribute('aria-expanded', String(open));
    };

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });

    items.push({ column, heading, list });
  });

  const sync = () => {
    footer.classList.toggle('cp-footer-acc', phone.matches);

    items.forEach(({ column, heading, list }) => {
      if (phone.matches) {
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-controls', list.id);
        heading.setAttribute('aria-expanded', String(column.classList.contains('is-open')));
      } else {
        column.classList.remove('is-open');
        ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach((name) => heading.removeAttribute(name));
      }
    });
  };

  sync();
  phone.addEventListener('change', sync);
})();